import React from 'react';
import {UsePermissions} from "../../hooks/usePermissions";

import {Navigate} from "react-router";
import {ContainerTitleTable} from "../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../components/Containers/ContainerTable";
import {InformeCompensacion} from "../../components/Informes/InformeCompensacion";

export const InformeCompensacionPage = () => {
  const [permisos] = UsePermissions();
  return (
      <div className="container-relative">
        <ContainerTitleTable>
          {permisos.submenu}
        </ContainerTitleTable>
        <ContainerTable>
          <div className="px-2">
            {permisos.consultar ? <InformeCompensacion />: <Navigate to="/home"/>}
          </div>

        </ContainerTable>

      </div>
  );
}
